<template>
  <div class="addPackageWrapper">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput label="Наименование" placeholder="Введите наименование" type="text"
          :value="formData.work_set_name || ''" @change_input="value => onChange('work_set_name', value)" />
      </div>

      <div class="form__item">
        <div>
          <CustomCheckbox label="Без оплаты" :value="formData.without_pay"
            @change="(value) => onChange('without_pay', value)" />
        </div>
      </div>

      <div class="form__item">
        <CustomSelect :options="unitsListOptions" label="Ед.измерения" optionValueKey="unit_id"
          optionLabelKey="unit_name" :required="true" placeholder="Выберите единицу измерения"
          :value="formData.unit_id || ''" @change="(value) => onChange('unit_id', value)"
          class="select-with-button__select" />
      </div>

      <div class="form__item">
        <CustomInput label="Формула" placeholder="Введите формулу" type="text" :value="formData.formula || ''"
          @change_input="value => onChange('formula', value)" />
      </div>

      <div class="form__item">
        <div class="select-with-button">
          <CustomSelect :options="groupConstructiveListOptions" label="Группа работ"
            optionValueKey="work_set_check_group_id" optionLabelKey="work_set_check_group_name" :required="true"
            placeholder="Выберите группу работ" :value="formData.work_set_check_group_id || ''"
            @change="(value) => onChange('work_set_check_group_id', value)" class="select-with-button__select" />
          <q-btn @click="openCreateGroupConstructiveModal" class="select-with-button__btn" color="primary" icon="add"
            round size="sm" flat />
        </div>
      </div>
      <CustomModalFooter :btn-loading="loading" submit-btn-text="Занести" />
    </q-form>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from "vue"
import { useQuery } from "@tanstack/vue-query"
import CustomSelect from "@/components/form/CustomSelect"
import CustomModalFooter from "@/components/modal/modals/modal-footer"
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomInput from "@/components/form/CustomInput"
import { useAppStore } from "@/services/store/app"
import {
  getGoupConstructiveList,
} from "@/views/PackageEntry/services"
import { getUnitsList } from "@/views/Materials/services"

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  closeModal: {
    type: Function,
    default: () => { },
  },
});

const appStore = useAppStore();
const loading = ref(false);
const selectedSet = ref(null);
const formData = reactive({
  contractor_work_set_id: props.data.body.contractor_work_set_id || "",
  preset_kit_id: props.data.body.preset_kit_id || "",
  work_set_id: props.data.body.work_set_id || "",
  work_set_name: props.data.body.work_set_name || "",
  formula: props.data.body.formula || "",
  unit_id: props.data.body.unit_id || "",
  unit_name: props.data.body.unit_name || "",
  work_set_check_group_id: props.data.body.work_set_check_group_id || "",
  work_set_check_group_name: props.data.body.work_set_check_group_name || "",
  without_pay: props.data.body.without_pay || false,
  is_default: props.data.body.is_default || null,
});

const { data: groupConstructiveListData, refetch: refetchGroupConstructiveList } = useQuery({
  queryKey: computed(() => ["groupConstructiveList"]),
  queryFn: () => getGoupConstructiveList(),
  refetchOnWindowFocus: false,
});

const { data: unitsListData } = useQuery({
  queryKey: ['unitsList'],
  queryFn: () => getUnitsList(),
});

const unitsListOptions = computed(() => unitsListData.value || []);

const groupConstructiveListOptions = computed(() => groupConstructiveListData.value || []);

const onChange = (key, value, row) => {
  formData[key] = value;

  if (key === "material_id") {
    formData.material_set_id = "";
    createdMaterialSetItems.value = [];
  }

  if (key === "material_set_id") {
    createdMaterialSetItems.value = [];
    selectedSet.value = row || null

    if (value) {
      getSetMaterials()
    }
  }
};

const openCreateGroupConstructiveModal = () => {
  appStore.showSecondaryModal("CreateConstructiveGroupSet", {
    title: "Создать группу",
    onClose: async (work_set_check_group_id, work_set_check_group_name) => {
      await refetchGroupConstructiveList();
      if (work_set_check_group_id) {
        formData.work_set_check_group_id = work_set_check_group_id;
        formData.work_set_check_group_name = work_set_check_group_name;
      }
    },
  });
};

const onSubmit = async () => {
  if (!formData.work_set_id || !formData.work_set_check_group_id) {
    return
  }

  loading.value = true
  const body = {
    contractor_work_set_id: formData.contractor_work_set_id,
    preset_kit_id: formData.preset_kit_id,
    without_pay: formData.without_pay,
    work_set_id: formData.work_set_id,
    work_set_name: formData.work_set_name,
    formula: formData.formula,
    unit_id: formData.unit_id,
    work_set_check_group_id: formData.work_set_check_group_id,
  }

  await props.data?.onSubmit(body)
  loading.value = false
}
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 700px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 15px;
  margin-top: 15px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}

.work-set-info {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e0e0e0;

  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .info-label {
      font-weight: 500;
      color: #666;
      font-size: 14px;
    }

    .info-value {
      font-weight: 600;
      color: #333;
      font-size: 14px;
    }
  }
}

.select-with-button {
  display: flex;
  align-items: flex-end;
  gap: 8px;

  &__select {
    flex: 1;
  }

  &__btn {
    margin-bottom: 2px;
  }
}
</style>
